import { FaSearch } from "react-icons/fa";

const InputClientes = ({ 
  valor, 
  onClick, 
  placeholder = "Buscar cliente...", 
  nombreCliente,
  editable = true
}) => {
  
  // Si no hay un nombreCliente, se usa el placeholder.
  const clienteNombre = nombreCliente || placeholder;

  return (
    <button
      type="button"
      onClick={() => editable && onClick(valor)}
      disabled={!editable}
      className={`w-full flex items-center justify-between p-2 rounded-xl text-gray-700 border border-gray-400 transition-colors ${
        editable 
          ? 'bg-white hover:border-verde-oscuro cursor-pointer' 
          : 'bg-gray-100 cursor-not-allowed opacity-70'
      }`}
    >
      <span className="truncate text-left">{clienteNombre}</span>
      <FaSearch className={editable ? "text-verde-claro ml-2" : "text-gray-400 ml-2"} />
    </button>
  );
};

export default InputClientes;
